<app-colored-background [backgroundColor]="'#03A97F'">
  <app-header
    [title]="locale.currentTranslation.documentUploadHeader"
    [useWhiteFontColor]="true"
    [showProgressIndicator]="false"
    [showClose]="false"
    data-testid="document-upload-finished-header"
  ></app-header>
  <div data-testid="document-upload-finished-container">
    <div class="base-content-container" data-testid="document-upload-finished-content">
      <div class=headline1 style="color: #FFFFFF" data-testid="document-upload-finished-headline">
        {{ locale.currentTranslation.documentUploadFinishedHeadline }}
      </div>
      <div class="text-body1" style="color: #FFFFFF" data-testid="document-upload-finished-text">
        {{ locale.currentTranslation.documentUploadFinishedText }}
      </div>
    </div>
    <app-finish-box data-testid="document-upload-finished-finish-box"></app-finish-box>
    <div class="main-button-spacing" data-testid="document-upload-finished-button-container">
      <button class="main-button" routerLink="/personal-information" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
    </div>
  </div>

  <app-footer data-testid="document-upload-finished-footer"></app-footer>
</app-colored-background>
